import { Input } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useUnstaleCleanup } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setEdits } from '../SpreadSheetDataProvider/actions'

BaseEditingAttributesCell = ({ value, immediatelyWrite, initialValue, children, r, c }) ->

  [{
    edits,
    isEscapingEditMode
  }, dispatch] = useSpreadSheetData()

  valueDidntChange = (value) ->
    val = value.toString()
    edit = edits[r]?[c]?.toString()
    init = initialValue.toString()
    val is edit or val is init

  onWriteEdit = (value) ->
    return if isEscapingEditMode or valueDidntChange(value)

    localEdits = _.mapValues(edits, (val) -> { val... })
    localEdits[r] ?= {}
    localEdits[r][c] = value

    dispatch(setEdits({
      prevEdits: { edits... }
      nextEdits: { localEdits... }
    }))

  if immediatelyWrite
    useEffect( ->
      onWriteEdit(value)
    , [value])
  else
    useUnstaleCleanup( ->
      onWriteEdit(value)
    )

  children

export default BaseEditingAttributesCell
